import React from 'react';
import './Backdrop.css';

const Backdrop = ({ children, show }) => {
    return show ? <div className="backdrop">{children}</div> : null;
};

export default Backdrop;